import httpClient, { catchError } from '@emmacare/common/api/httpClient'

// store
import {
  setActivitiesList,
  setActivitiesStatistics
} from 'src/store/modules/activities'

import {
  ACTIVITIES_GET_LIST,
  PATIENT_PATCH_AGENCY_CASE_MANAGERS
} from 'src/utils/constants'

export const fetchActivitiesList =
  ({ params = {}, query = {} }) =>
  async (dispatch: any) => {
    try {
      const {
        items = [],
        statistics = {},
        meta = {}
      } = await httpClient.request({
        method: 'get',
        url: {
          pathname: ACTIVITIES_GET_LIST,
          params,
          query
        }
      })

      dispatch(setActivitiesList(items))
      dispatch(setActivitiesStatistics(statistics))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updatePatientAgencyCaseManager =
  (config: any = {}) =>
  async () => {
    const { payload = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: PATIENT_PATCH_AGENCY_CASE_MANAGERS
        },
        payload
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
